document.addEventListener("DOMContentLoaded", function () {
  // add logic to detect status/position of bundle builder process
  Shopify.Cart = {
    add: async (id, quantity, properties) => {
      let response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id,
          quantity,
          properties,
        }),
      });
      let data = await response.json();
      // console.log(data);
    },
    update: async (products) => {
      // Expecting products to be an array of objects like [{key: "123:abc", quantity: 2}, {key: "456:def", quantity: 0}]

      // Fetch the current cart to get the ordered list of line items
      let cart = await Shopify.Cart.get();
      let line_items = cart.items;

      // Create a map from line item key to new quantity for quick lookup
      let updateMap = {};
      products.forEach((product) => {
        updateMap[product.key] = product.quantity;
      });

      // Build the updates array: for each line item, use the new quantity if specified, else its current quantity
      let updates = line_items.map((item) => {
        if (updateMap.hasOwnProperty(item.key)) {
          return updateMap[item.key];
        } else {
          return item.quantity;
        }
      });

      // Send the updates array to the Shopify API
      let response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      let data = await response.json();
      // console.log(data);
      return data; // Return the updated cart data
    },
    clear: async () => {
      let response = await fetch("/cart/clear.js", {
        method: "POST",
      });
      let data = await response.json();
      // console.log(data);
    },
    get: async () => {
      let response = await fetch("/cart.js");
      let data = await response.json();
      console.log("getData:", data);
      return data;
    },
    addTest: async () => {
      let response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: 54328644403524,
          quantity: 1,
          properties: {
            _BB_index: 1,
          },
        }),
      });
      let data = await response.json();
      // console.log(data);
    },
  };

  window.BundleBuilder = {
    currentCart: async () => {
      await window.BundleBuilder.checkBrokenCart();
      let step = await window.BundleBuilder.getStep();
      const introContainer = document.querySelector(
        ".bundle-builder-intro__container"
      );

      initProgressButtons(introContainer, step);
    },

    goToStep: async (step) => {
      1;
      let cart = await Shopify.Cart.get();
      let line_items = cart.items;

      let items_to_remove = [];

      for (let i = 0; i < line_items.length; i++) {
        let item = line_items[i];
        if (item.properties && item.properties._BB_index !== undefined && item.properties._BB_index >= step) {
          // console.log("Removing item", item);
          items_to_remove.push({ key: item.key, quantity: 0 });
        }
      }

      if (items_to_remove.length > 0) {
        await Shopify.Cart.update(items_to_remove);
        // Wait for server to process the update, then verify
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Verify the cart was updated correctly by checking it again
        let verifyCart = await Shopify.Cart.get();
        let hasItemsToRemove = false;
        for (let i = 0; i < verifyCart.items.length; i++) {
          let item = verifyCart.items[i];
          if (item.properties && item.properties._BB_index !== undefined && item.properties._BB_index >= step) {
            hasItemsToRemove = true;
            break;
          }
        }
        
        // If items still exist, wait a bit more and try once more
        if (hasItemsToRemove) {
          await new Promise(resolve => setTimeout(resolve, 300));
          await Shopify.Cart.update(items_to_remove);
          await new Promise(resolve => setTimeout(resolve, 300));
        }
      }
      
      // Always update total after cart operations complete
      await updateCartTotal();
    },

    getStep: async () => {
      let cart = await Shopify.Cart.get();
      let line_items = cart.items;

      let max_index = -1;

      for (let i = 0; i < line_items.length; i++) {
        let item = line_items[i];
        if (item.properties && item.properties._BB_index !== undefined && item.properties._BB_index > max_index) {
          max_index = item.properties._BB_index;
        }
      }

      return max_index;
    },

setUpSwipers: () => {
  const swiperContainers = document.querySelectorAll(".swiper");
  swiperContainers.forEach((container, index) => {
    const swiper = new Swiper(container, {
      direction: "horizontal",
      spaceBetween: 10,
      mousewheel: false,
      adaptiveHeight: true,
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        clickable: true,
      },
      keyboard: { 
        enabled: true,
      },
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      
      slidesPerView: 3,
      grid: {
        rows: 2,
        fill: "row", // "row" fills row by row, "column" fills column by column
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          grid: { rows: 1 },
        },
        600: {
          slidesPerView: 2,
          grid: { rows: 1 },
        },
        1024: {
          slidesPerView: 3,
          grid: { rows: 2 },
        },
      },
    });
    swiper.init();
  });
},


    checkBrokenCart: async () => {
      try {
        // Step 1: Fetch the current cart
        let cart = await Shopify.Cart.get();
        let line_items = cart.items;

        // Step 2: Find items with _BB_index property
        let bb_items = line_items.filter(
          (item) => item.properties && item.properties._BB_index !== undefined
        );

        // If no items have _BB_index, exit early
        if (bb_items.length === 0) {
          return;
        }

        // Step 3: Collect all _BB_index values and find the maximum
        let bb_indices = new Set(
          bb_items.map((item) => item.properties._BB_index)
        );
        let max_index = Math.max(...bb_indices);

        // Step 4: Check for gaps in the sequence (0 to max_index)
        let hasGaps = false;
        for (let i = 0; i <= max_index; i++) {
          if (!bb_indices.has(i)) {
            hasGaps = true;
            break;
          }
        }

        // Step 5: If gaps exist, remove all items with _BB_index
        if (hasGaps) {
          // console.log(`Found gaps in bundle sequence (0-${max_index}), removing ${bb_items.length} items`);

          // Prepare items to remove by setting their quantities to 0
          let items_to_remove = bb_items.map((item) => ({
            key: item.key,
            quantity: 0,
          }));

          // console.log("Items to remove:", items_to_remove);

          // Step 6: Update the cart to apply removals
          await Shopify.Cart.update(items_to_remove);
          // console.log("Bundle items removed due to broken sequence");
        } else {
          // console.log("Bundle sequence intact, no action taken");
        }
      } catch (error) {
        // console.error("Error checking broken cart:", error);
        throw error; // Let the caller handle the error if needed
      }
    },
  };
  // must precede all other logic

  function initProgressButtons(introContainer, step) {
    const sliderContainers = document.querySelectorAll(
      ".bundle-builder-step__container"
    );
    const outroContainer = document.querySelector(
      ".bundle-builder-outro__container"
    );
    const continueBtn = document.querySelector(".bb-progress__button.primary");
    const startAgainBtn = document.querySelector(
      ".bb-progress__button.secondary"
    );
    const initBtn = introContainer.querySelector(".bb-button");

    continueBtn.addEventListener("click", () => {
      let nextContainer =
        sliderContainers.length - 1 === step
          ? outroContainer
          : sliderContainers[step + 1];
      console.log(sliderContainers.length, step);
      fadeOutOldLoaderStart(introContainer, nextContainer);
      document.getElementById("bb-progress").classList.remove("visible");
    });

    startAgainBtn.addEventListener("click", () => {
      console.log("start again");
      window.BundleBuilder.goToStep(0);
      initBtn.removeAttribute("disabled");
      document.getElementById("bb-progress").classList.remove("visible");
    });

    if (step >= 0) {
      document.getElementById("bb-progress").classList.add("visible");
    } else {
      initBtn.removeAttribute("disabled");
      document.getElementById("bb-progress").classList.remove("visible");
    }
  }

  // Cart total update queue to prevent race conditions - defined early
  let cartUpdateQueue = Promise.resolve();
  let isUpdatingCart = false;

  function queueCartTotalUpdate(delay = 0) {
    cartUpdateQueue = cartUpdateQueue.then(async () => {
      if (delay > 0) {
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      return updateCartTotal();
    }).catch(error => {
      console.error('Error in cart total update queue:', error);
    });
  }

  async function updateCartTotal() {
    if (isUpdatingCart) {
      return; // Prevent concurrent updates
    }
    
    isUpdatingCart = true;
    try {
      // Get fresh cart data with retry logic
      let cart;
      let retries = 3;
      
      while (retries > 0) {
        try {
          cart = await Shopify.Cart.get();
          break;
        } catch (error) {
          retries--;
          if (retries > 0) {
            await new Promise(resolve => setTimeout(resolve, 200));
          } else {
            // If cart fetch fails, just return - don't break the page
            return;
          }
        }
      }
      
      if (!cart) return;
      
      const totalPrice = cart.total_price || 0;
      const formattedTotal = (totalPrice / 100).toFixed(2);
      
      // Update all cart total elements smoothly
      const totalElements = document.querySelectorAll('.bb-cart-total');
      if (totalElements.length > 0) {
        totalElements.forEach(element => {
          // Add smooth transition
          element.style.transition = 'opacity 0.2s ease';
          element.style.opacity = '0.7';
          element.textContent = `£${formattedTotal}`;
          // Fade back in
          setTimeout(() => {
            element.style.opacity = '1';
          }, 50);
        });
      }
    } catch (error) {
      console.error('Error updating cart total:', error);
      // Don't throw - just log the error
    } finally {
      isUpdatingCart = false;
    }
  }

  function initCartTotal() {
    try {
      // Update cart total when cart changes
      document.addEventListener('cart:updated', () => {
        queueCartTotalUpdate();
      });
      
      // Initial update - but don't break if it fails
      setTimeout(() => {
        queueCartTotalUpdate();
      }, 500);
    } catch (error) {
      console.error('Error initializing cart total:', error);
      // Don't break the page if cart total init fails
    }
  }

  initTransitions();
  initBundleProductSelection();
  initProductInfoPopups();
  initSkipAndBackButtons();
  initCartTotal();
  showBottomBarOnAllSteps();
  initBundleAddToBagLabels();

  // Add loading state to buttons to be disabled and show loader

  const loader = document.querySelector(".loader-container");

  function initTransitions() {
    const introContainer = document.querySelector(
      ".bundle-builder-intro__container"
    );
    const sliderContainers = document.querySelectorAll(
      ".bundle-builder-step__container"
    );
    const outroContainer = document.querySelector(
      ".bundle-builder-outro__container"
    );
    const initBtn = introContainer.querySelector(".bb-button");

    window.BundleBuilder.currentCart();
    window.BundleBuilder.setUpSwipers();
    initStepIntros(sliderContainers);

    initBtn.addEventListener("click", () => {
      fadeOutOldLoaderStart(introContainer, sliderContainers[0]);
    });

    sliderContainers.forEach((sliderContainer, sliderIndex) => {
      handleSlidersAtc();

      initDots().then(handleDotsLinks).then(console.log).catch(console.error);

      function handleSlidersAtc() {
        sliderContainer.querySelectorAll("product-form").forEach((btn) => {
          const productId = btn.querySelector(".product-variant-id").value;
          btn.addEventListener("click", async (event) => {
            event.preventDefault();
            // Remove any existing items from this step first to prevent duplicates
            const cart = await Shopify.Cart.get();
            const itemsToRemove = [];
            cart.items.forEach(item => {
              if (item.properties && item.properties._BB_index === sliderIndex) {
                itemsToRemove.push({ key: item.key, quantity: 0 });
              }
            });
            if (itemsToRemove.length > 0) {
              await Shopify.Cart.update(itemsToRemove);
              await new Promise(resolve => setTimeout(resolve, 200));
            }
            // Then add the new item
            await Shopify.Cart.add(productId, 1, { _BB_index: sliderIndex });
            // Queue cart total update
            queueCartTotalUpdate(300);
            if (sliderIndex === sliderContainers.length - 1) {
              fadeOutOldLoaderStart(sliderContainer, outroContainer);
            } else {
              fadeOutOldLoaderStart(
                sliderContainer,
                sliderContainers[sliderIndex + 1]
              );
            }
          });
        });
      }

      async function initDots() {
        const stepsContainer =
          sliderContainer.querySelector(".bb-overlay__steps");
        const dots = stepsContainer.querySelectorAll("li");

        dots.forEach((dot, i) => {
          if (i === sliderIndex) {
            dot.dataset.active = "true";
          } else {
            dot.removeAttribute('[data-active="true"]');
            if (i < sliderIndex) {
              dot.dataset.step = i;
            }
          }
        });
      }

      async function handleDotsLinks() {
        //  select and loop through the dots with the data atts and add event listeners to em
        const dots = sliderContainer.querySelectorAll(
          ".bb-overlay__steps [data-step]"
        );
        dots.forEach((dot) => {
          dot.addEventListener("click", async () => {
            const dotIndex = parseInt(dot.dataset.step);
            await window.BundleBuilder.goToStep(dotIndex);
            fadeOutOldLoaderStart(sliderContainer, sliderContainers[dotIndex]);
          });
        });
      }
    });
  }

  function fadeOutOldLoaderStart(containerToHide, containerToShow) {
    console.log("h:", containerToHide);
    
    // Determine if we're navigating back by comparing step indices
    const sliderContainers = document.querySelectorAll('.bundle-builder-step__container');
    const hideIndex = Array.from(sliderContainers).indexOf(containerToHide);
    const showIndex = Array.from(sliderContainers).indexOf(containerToShow);
    const isNavigatingBack = hideIndex > showIndex && showIndex >= 0;
    
    // Store navigation direction on the container
    if (isNavigatingBack) {
      containerToShow.dataset.navigatingBack = 'true';
    } else {
      containerToShow.removeAttribute('data-navigating-back');
    }
    
    containerToHide.classList.add("fade-out");
    containerToHide.addEventListener(
      "transitionend",
      function () {
        containerToHide.classList.remove("fade-in");
        containerToHide.classList.remove("fade-out");
        containerToHide.classList.remove("show");
        containerToHide.classList.add("hide");
        // Begin Loader for x seconds
        loader.classList.add("show");
        loader.addEventListener(
          "animationend",
          function () {
            loaderEndFadeInNew(containerToShow);
            console.log("s:", containerToShow);
            loader.classList.remove("show");
            loader.classList.add("hide");
          },
          { once: true }
        );
      },
      { once: true }
    );
  }

  function loaderEndFadeInNew(containerToShow) {
    containerToShow.classList.remove("hide");
    containerToShow.classList.add("show");
    
    // If showing outro, display selected products
    if (containerToShow.classList.contains("bundle-builder-outro__container")) {
      setTimeout(() => {
        displaySelectedProductsInOutro();
      }, 500);
    }
    
    // Add Promise Here
    if (containerToShow.classList.contains("bundle-builder-step__container")) {
      const background = containerToShow.querySelector("[data-step-background]");
      
      // Always ensure background is visible for all steps
      if (background) {
        containerToShow.classList.remove("bb-step-bg-hidden");
        // Make sure background element is visible
        background.style.display = '';
        const videos = background.querySelectorAll("video");
        const images = background.querySelectorAll("img");
        
        // Play videos
        videos.forEach(video => {
          video.play().catch(e => {
            // Ignore autoplay errors
            console.log("Video autoplay prevented:", e);
          });
        });
        
        // Ensure images are visible
        images.forEach(img => {
          img.style.display = '';
        });
      }
      
      updateStepBottomBar(containerToShow);
      
      // Check if we're navigating back using the data attribute set in fadeOutOldLoaderStart
      const isNavigatingBack = containerToShow.dataset.navigatingBack === 'true';
      
      // If navigating back, show content directly (skip intro overlay)
      if (isNavigatingBack && containerToShow.classList.contains('bundle-builder-step__container')) {
        const intro = containerToShow.querySelector("[data-step-intro]");
        const content = containerToShow.querySelector("[data-step-content]");
        if (intro) {
          intro.classList.add("is-hidden");
        }
        if (content) {
          content.classList.remove("is-hidden");
        }
        // Ensure background is visible
        containerToShow.classList.remove("bb-step-bg-hidden");
        // Ensure videos/images are playing/visible
        if (background) {
          const videos = background.querySelectorAll("video");
          videos.forEach(video => {
            video.play().catch(e => {
              console.log("Video autoplay prevented:", e);
            });
          });
        }
        // Remove the flag after using it
        containerToShow.removeAttribute('data-navigating-back');
      } else if (containerToShow.dataset.stepHasIntro) {
        showStepIntro(containerToShow);
      } else {
        // If step doesn't have intro, show content immediately
        const content = containerToShow.querySelector("[data-step-content]");
        if (content) {
          content.classList.remove("is-hidden");
        }
      }
    }
    initBundleAddToBagLabels(containerToShow);

    setTimeout(() => {
      containerToShow.classList.add("fade-in");
    }, 100);
    // containerToShow.addEventListener('transitionend', function() {
    //   containerToShow.classList.remove('fade-in');
    // });
  }

  function initStepIntros(sliderContainers) {
    if (!sliderContainers || sliderContainers.length === 0) {
      return;
    }

    sliderContainers.forEach((container) => {
      if (!container.dataset.stepHasIntro) {
        return;
      }

      showStepIntro(container);

      const introButton = container.querySelector("[data-step-intro-btn]");
      if (introButton) {
        introButton.addEventListener("click", () => {
          revealStepContent(container);
        });
      }
    });
  }

  function showStepIntro(container) {
    if (!container || !container.dataset.stepHasIntro) {
      return false;
    }

    const intro = container.querySelector("[data-step-intro]");
    const content = container.querySelector("[data-step-content]");
    const background = container.querySelector("[data-step-background]");

    if (!intro || !content) {
      return false;
    }

    // Play any videos in the background
    if (background) {
      const videos = background.querySelectorAll("video");
      videos.forEach(video => {
        video.play().catch(e => {
          // Ignore autoplay errors
          console.log("Video autoplay prevented:", e);
        });
      });
    }

    container.classList.remove("bb-step-bg-hidden");
    intro.classList.remove("is-hidden");
    content.classList.add("is-hidden");
    return true;
  }

  function revealStepContent(container) {
    if (!container) {
      return false;
    }

    const intro = container.querySelector("[data-step-intro]");
    const content = container.querySelector("[data-step-content]");
    const background = container.querySelector("[data-step-background]");

    if (!content) {
      return false;
    }

    // Hide intro if it exists
    if (intro) {
      intro.classList.add("is-hidden");
    }

    // Keep videos playing and images visible in the background when product grid is shown
    if (background) {
      // Don't hide background - keep it visible
      container.classList.remove("bb-step-bg-hidden");
      background.style.display = '';
      
      const videos = background.querySelectorAll("video");
      const images = background.querySelectorAll("img");
      
      // Play videos
      videos.forEach(video => {
        video.play().catch(e => {
          // Ignore autoplay errors
          console.log("Video autoplay prevented:", e);
        });
      });
      
      // Ensure images are visible
      images.forEach(img => {
        img.style.display = '';
      });
    }

    // Show the content overlay
    content.classList.remove("is-hidden");
    updateStepBottomBar(container);
    queueCartTotalUpdate();
    return true;
  }

  function initSkipAndBackButtons() {
    document.addEventListener('click', function(event) {
      const skipBtn = event.target.closest('.skip-btns > button');
      const backBtn = event.target.closest('.mybtns-vs .left-b > button');

      if (skipBtn) {
        const currentContainer = skipBtn.closest('.bundle-builder-step__container');
        if (!currentContainer) return;

        const sliderContainers = document.querySelectorAll('.bundle-builder-step__container');
        const outroContainer = document.querySelector('.bundle-builder-outro__container');
        const currentIndex = Array.from(sliderContainers).indexOf(currentContainer);

        const nextContainer = currentIndex === sliderContainers.length - 1
          ? outroContainer
          : sliderContainers[currentIndex + 1];

        fadeOutOldLoaderStart(currentContainer, nextContainer);
        return;
      }

      if (backBtn) {
        event.preventDefault();
        const currentContainer = backBtn.closest('.bundle-builder-step__container');
        if (!currentContainer) return;

        const introContainer = document.querySelector('.bundle-builder-intro__container');
        const sliderContainers = document.querySelectorAll('.bundle-builder-step__container');
        const currentIndex = Array.from(sliderContainers).indexOf(currentContainer);

        // Remove items from current step and all later steps, then navigate
        const navigateBack = async () => {
          if (currentIndex >= 0) {
            // Wait for cart update to complete and total to be updated
            await window.BundleBuilder.goToStep(currentIndex);
            // Small additional delay to ensure UI reflects the change
            await new Promise(resolve => setTimeout(resolve, 200));
          }
          
          const prevContainer = currentIndex > 0 ? sliderContainers[currentIndex - 1] : introContainer;
          if (prevContainer) {
            fadeOutOldLoaderStart(currentContainer, prevContainer);
            // Update total one more time after navigation animation completes to ensure accuracy
            setTimeout(async () => {
              await updateCartTotal();
            }, 1000);
          }
        };
        
        navigateBack();
      }
    });
  }

  function initBundleProductSelection() {
    // Handle "Choose Option" button clicks for multi-variation products
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('bundle-choose-option')) {
        event.preventDefault();
        
        const button = event.target;
        const productId = button.dataset.productId;
        const productUrl = button.dataset.productUrl;
        
        // Find the current slider container
        const sliderContainer = button.closest('.bundle-builder-step__container');
        if (!sliderContainer) return;
        
        // Hide all product slides except the selected one
        const allSlides = sliderContainer.querySelectorAll('.swiper-slide');
        const selectedSlide = button.closest('.swiper-slide');
        
        allSlides.forEach(slide => {
          if (slide !== selectedSlide) {
            slide.style.display = 'none';
          }
        });
        
        // Transform the selected product into a single product view
        transformToSingleProductView(selectedSlide, productId, productUrl, sliderContainer);
      }
    });
  }

  function transformToSingleProductView(selectedSlide, productId, productUrl, sliderContainer) {
    // Get the product title from the selected slide
    const productTitleElement = selectedSlide.querySelector('.card__heading a, .card__heading h3, .card__heading');
    const productTitle = productTitleElement ? productTitleElement.textContent.trim() : 'Product';
    
    // Create a new variations view container
    const variationsView = document.createElement('div');
    variationsView.className = 'bb-variations-view';
    variationsView.innerHTML = `
      <div class="bb-variations-container">
        <div class="bb-variations-header">
          <div class="bb-variations-title-section">
            <h2 class="bb-main-product-title">${productTitle}</h2>
            <h3 class="bb-variations-title">Choose Your Option</h3>
          </div>
          <button class="button button--secondary bundle-back-to-selection" type="button">
            Back to Selection
          </button>
        </div>
        <div class="bb-variations-grid" id="bb-variations-grid-${productId}">
          <div class="bb-loading-variations">Loading variations...</div>
        </div>
      </div>
    `;
    
    // Hide the swiper container
    const swiperContainer = sliderContainer.querySelector('.swiper');
    if (swiperContainer) {
      swiperContainer.style.display = 'none';
    }
    
    // Insert the variations view
    const bundleCollection = sliderContainer.querySelector('.test');
    if (bundleCollection) {
      bundleCollection.appendChild(variationsView);
    }
    
    // Load the product variations
    loadProductVariations(productId, productUrl, sliderContainer);
    
    // Handle back to selection button
    variationsView.querySelector('.bundle-back-to-selection').addEventListener('click', function() {
      // Show all slides again
      const allSlides = sliderContainer.querySelectorAll('.swiper-slide');
      allSlides.forEach(slide => {
        slide.style.display = '';
      });
      
      // Show swiper container
      if (swiperContainer) {
        swiperContainer.style.display = '';
      }
      
      // Remove variations view
      variationsView.remove();
    });
  }

  function loadProductVariations(productId, productUrl, sliderContainer) {
    // Extract product handle from URL
    const productHandle = productUrl.split('/').pop();
    
    // Fetch product data from Shopify API
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product); // Debug log
        const variationsGrid = document.getElementById(`bb-variations-grid-${productId}`);
        if (!variationsGrid) return;
        
        // Clear loading message
        variationsGrid.innerHTML = '';
        
        // Create a card for each variation
        product.variants.forEach((variant, index) => {
          console.log(`Variant ${index}:`, variant); // Debug log
          const variationCard = createVariationCard(product, variant, productId, sliderContainer);
          variationsGrid.appendChild(variationCard);
        });
      })
      .catch(error => {
        console.error('Error loading product variations:', error);
        const variationsGrid = document.getElementById(`bb-variations-grid-${productId}`);
        if (variationsGrid) {
          variationsGrid.innerHTML = '<div class="bb-error-loading">Error loading variations. Please try again.</div>';
        }
      });
  }

  function createVariationCard(product, variant, productId, sliderContainer) {
    const card = document.createElement('div');
    card.className = 'bb-variation-card';
    
    // Get variant image - try variant image first, then product images
    let imageUrl = '';
    if (variant.featured_image && variant.featured_image.src) {
      imageUrl = variant.featured_image.src;
    } else if (product.images && product.images.length > 0) {
      // Use the first product image as fallback
      imageUrl = product.images[0];
    }
    
    // Format price
    const price = variant.price ? (variant.price / 100).toFixed(2) : '0.00';
    const comparePrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;
    
    // Create variant title structure like in the image
    let mainProductTitle = product.title;
    let variationOption = '';
    
    // Get the first non-default option as the variation (like "60cm", "70cm", "80cm")
    if (variant.option1 && variant.option1 !== 'Default Title') {
      variationOption = variant.option1;
    } else if (variant.option2 && variant.option2 !== 'Default Title') {
      variationOption = variant.option2;
    } else if (variant.option3 && variant.option3 !== 'Default Title') {
      variationOption = variant.option3;
    }
    
    // If no specific option found, use the variant title if it's different from product title
    if (!variationOption && variant.title && variant.title !== 'Default Title' && variant.title !== product.title) {
      variationOption = variant.title.replace(product.title, '').trim();
    }
    
    card.innerHTML = `
      <div class="bb-variation-card-inner">
        <div class="bb-variation-header">
          ${variationOption ? `<span class="bb-variation-option">${variationOption}</span>` : ''}
          <span class="bb-main-product-name">${mainProductTitle}</span>
        </div>
        <div class="bb-variation-image">
          ${imageUrl ? `<img src="${imageUrl}" alt="${mainProductTitle}" loading="lazy" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">` : ''}
          <div class="bb-no-image-placeholder" style="display: ${imageUrl ? 'none' : 'flex'};">
            <span>No Image</span>
          </div>
        </div>
        <div class="bb-variation-details">
          <div class="bb-variation-price">
            ${comparePrice ? `<span class="bb-compare-price">£${comparePrice}</span>` : ''}
            <span class="bb-current-price">£${price}</span>
          </div>
          <button class="button button--primary bb-variation-add-to-cart" 
                  data-variant-id="${variant.id}" 
                  data-product-id="${productId}"
                  ${!variant.available ? 'disabled' : ''}>
            ${variant.available ? 'Add to Basket' : 'Sold Out'}
          </button>
        </div>
      </div>
    `;
    
    // Add click handler for add to cart
    const addToCartBtn = card.querySelector('.bb-variation-add-to-cart');
    addToCartBtn.addEventListener('click', async function() {
      if (!variant.available) return;
      
      // Find the current step index
      const sliderContainers = document.querySelectorAll('.bundle-builder-step__container');
      const currentStepIndex = Array.from(sliderContainers).indexOf(sliderContainer);
      
      // Remove any existing items from this step first to prevent duplicates
      const cart = await Shopify.Cart.get();
      const itemsToRemove = [];
      cart.items.forEach(item => {
        if (item.properties && item.properties._BB_index === currentStepIndex) {
          itemsToRemove.push({ key: item.key, quantity: 0 });
        }
      });
      if (itemsToRemove.length > 0) {
        await Shopify.Cart.update(itemsToRemove);
        await new Promise(resolve => setTimeout(resolve, 200));
      }
      // Then add the new item
      await Shopify.Cart.add(variant.id, 1, { _BB_index: currentStepIndex });
      // Queue cart total update
      queueCartTotalUpdate(300);
      
      // Move to next step
      const outroContainer = document.querySelector('.bundle-builder-outro__container');
      if (currentStepIndex === sliderContainers.length - 1) {
        fadeOutOldLoaderStart(sliderContainer, outroContainer);
      } else {
        fadeOutOldLoaderStart(sliderContainer, sliderContainers[currentStepIndex + 1]);
      }
    });
    
    return card;
  }

  function initProductInfoPopups() {
    // Handle product info icon clicks
    document.addEventListener('click', function(event) {
      if (event.target.closest('.product-info-icon')) {
        event.preventDefault();
        
        const icon = event.target.closest('.product-info-icon');
        const productCard = icon.closest('.swiper-slide');
        const productLink = productCard.querySelector('a[href*="/products/"]');
        
        if (productLink) {
          const productUrl = productLink.href;
          const productHandle = productUrl.split('/').pop();
          showProductInfoPopup(productHandle, productUrl);
        }
      }
    });
  }

  function showProductInfoPopup(productHandle, productUrl) {
    // Create popup overlay
    const popupOverlay = document.createElement('div');
    popupOverlay.className = 'bb-product-info-popup-overlay';
    popupOverlay.innerHTML = `
      <div class="bb-product-info-popup">
        <div class="bb-product-info-popup-header">
          <h3 class="bb-product-info-popup-title">Product Information</h3>
          <button class="bb-product-info-popup-close" type="button" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="bb-product-info-popup-content">
          <div class="bb-product-info-loading">Loading product information...</div>
        </div>
      </div>
    `;
    
    // Add to body
    document.body.appendChild(popupOverlay);
    
    // Add close functionality
    const closeBtn = popupOverlay.querySelector('.bb-product-info-popup-close');
    const overlay = popupOverlay;
    
    closeBtn.addEventListener('click', () => {
      closeProductInfoPopup(overlay);
    });
    
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeProductInfoPopup(overlay);
      }
    });
    
    // Add escape key functionality
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeProductInfoPopup(overlay);
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);
    
    // Load product information
    loadProductInfo(productHandle, productUrl, popupOverlay);
  }

  function closeProductInfoPopup(overlay) {
    overlay.classList.add('fade-out');
    setTimeout(() => {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }, 300);
  }

  function loadProductInfo(productHandle, productUrl, popupOverlay) {
    const contentContainer = popupOverlay.querySelector('.bb-product-info-popup-content');
    
    console.log('Loading product info for handle:', productHandle);
    console.log('Product URL:', productUrl);
    
    // Fetch product data
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        console.log('Response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data loaded:', product);
        // Create product info content
        const productInfo = createProductInfoContent(product, productUrl);
        contentContainer.innerHTML = productInfo;
      })
      .catch(error => {
        console.error('Error loading product info:', error);
        contentContainer.innerHTML = `
          <div class="bb-product-info-error">
            <p>Sorry, we couldn't load the product information. Please try again later.</p>
            <p><small>Error: ${error.message}</small></p>
            <button class="button button--secondary" onclick="this.closest('.bb-product-info-popup-overlay').querySelector('.bb-product-info-popup-close').click()">
              Close
            </button>
          </div>
        `;
      });
  }

  function createProductInfoContent(product, productUrl) {
    // Format price
    const price = product.price ? (product.price / 100).toFixed(2) : '0.00';
    const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
    
    // Get product images
    const productImages = product.images || [];
    const featuredImage = product.featured_image || (productImages.length > 0 ? productImages[0] : '');
    
    // Show all images one after another
    let imageHtml = '';
    if (productImages.length > 0) {
      imageHtml = productImages.map((image, index) => 
        `<img src="${image}" alt="${product.title} - Image ${index + 1}" loading="lazy" class="bb-product-image" />`
      ).join('');
    } else {
      imageHtml = '<div class="bb-no-image">No Image Available</div>';
    }
    
    // Create description (use product description or metafields)
    let description = product.description || product.body_html || 'No description available.';
    
    // Clean up HTML description
    if (description.includes('<')) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = description;
      description = tempDiv.textContent || tempDiv.innerText || description;
    }
    
    // Don't limit description length for full info popup
    // if (description.length > 500) {
    //   description = description.substring(0, 500) + '...';
    // }
    
    // Get product options
    let optionsHtml = '';
    if (product.options && product.options.length > 0) {
      optionsHtml = '<div class="bb-product-options"><h4>Available Options:</h4><ul>';
      product.options.forEach(option => {
        if (option.name && option.values && option.values.length > 0) {
          optionsHtml += `<li><strong>${option.name}:</strong> ${option.values.join(', ')}</li>`;
        }
      });
      optionsHtml += '</ul></div>';
    }
    

    
    // Create product specifications/metafields section
    let specificationsHtml = '';
    if (product.metafields && Object.keys(product.metafields).length > 0) {
      specificationsHtml = '<div class="bb-product-specifications"><h4>Specifications:</h4><ul>';
      Object.entries(product.metafields).forEach(([key, value]) => {
        if (value && typeof value === 'string' && value.trim()) {
          const displayKey = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
          specificationsHtml += `<li><strong>${displayKey}:</strong> ${value}</li>`;
        }
      });
      specificationsHtml += '</ul></div>';
    }
    
    // Create product tags section
    let tagsHtml = '';
    if (product.tags && product.tags.length > 0) {
      tagsHtml = '<div class="bb-product-tags"><h4>Tags:</h4><div class="bb-tags-list">';
      product.tags.forEach(tag => {
        tagsHtml += `<span class="bb-tag">${tag}</span>`;
      });
      tagsHtml += '</div></div>';
    }
    
    return `
      <div class="bb-product-info-details-full">
        <div class="bb-product-info-main">
          <div class="bb-product-info-image">
            ${imageHtml}
          </div>
          <div class="bb-product-info-text">
            <h4 class="bb-product-info-name">${product.title}</h4>
            <div class="bb-product-info-price">
              ${comparePrice ? `<span class="bb-compare-price">£${comparePrice}</span>` : ''}
              <span class="bb-current-price">£${price}</span>
            </div>
            <div class="bb-product-info-description">
              <p>${description}</p>
            </div>
            ${optionsHtml}
            <div class="bb-product-info-actions">
              <a href="${productUrl}" class="button button--primary">View Full Details</a>
            </div>
          </div>
        </div>
        ${specificationsHtml}
        ${tagsHtml}
      </div>
    `;
  }


  function initBundleAddToBagLabels(root = document) {
    const targets =
      root.classList && root.classList.contains('bundle-builder-step__container')
        ? [root]
        : root.querySelectorAll
          ? root.querySelectorAll('.bundle-builder-step__container')
          : document.querySelectorAll('.bundle-builder-step__container');

    targets.forEach((container) => {
      container.querySelectorAll('button, a.button, .button, product-form button').forEach((el) => {
        if (/view\s+product/i.test(el.textContent.trim())) {
          el.textContent = 'Add to Bag';
        }

        el.querySelectorAll('span, p').forEach((child) => {
          if (/view\s+product/i.test(child.textContent.trim())) {
            child.textContent = 'Add to Bag';
          }
        });
      });
    });
  }

  function updateStepBottomBar(container) {
    if (!container) return;

    const bottomBar = container.querySelector('.skip-btns.mybtns-vs');
    if (!bottomBar) return;

    bottomBar.style.display = 'flex';
  }

  function showBottomBarOnAllSteps() {
    document.querySelectorAll('.bundle-builder-step__container').forEach((container) => {
      updateStepBottomBar(container);
    });
    queueCartTotalUpdate();
  }

  // Display selected products in outro
  async function displaySelectedProductsInOutro() {
    const outroContainer = document.querySelector('.bundle-builder-outro__container');
    if (!outroContainer) return;
    
    const productsContainer = document.getElementById('bb-outro-selected-products');
    if (!productsContainer) return;
    
    try {
      // Fetch cart
      const cart = await Shopify.Cart.get();
      
      // Filter items with _BB_index property and sort by step index
      const bundleItems = cart.items
        .filter(item => item.properties && item.properties._BB_index !== undefined)
        .sort((a, b) => {
          const indexA = parseInt(a.properties._BB_index) || 0;
          const indexB = parseInt(b.properties._BB_index) || 0;
          return indexA - indexB;
        });
      
      if (bundleItems.length === 0) {
        productsContainer.innerHTML = '<div class="bb-outro-products-loading">No products selected yet.</div>';
        return;
      }
      
      // Create title
      let html = '<h3 class="bb-outro-products-title">Your Selected Bundle</h3>';
      html += '<div class="bb-outro-products-grid">';
      
      // Fetch and display each product
      const productPromises = bundleItems.map(async (item) => {
        try {
          // Get product handle - try multiple methods
          let productHandle = '';
          
          // Method 1: From product_url
          if (item.product_url) {
            const urlMatch = item.product_url.match(/\/products\/([^\/\?]+)/);
            if (urlMatch) {
              productHandle = urlMatch[1];
            }
          }
          
          // Method 2: From handle property
          if (!productHandle && item.handle) {
            productHandle = item.handle;
          }
          
          // Method 3: Try fetching by product_id (if numeric)
          if (!productHandle && item.product_id) {
            try {
              // Try to fetch by product ID first (if it's a handle-like string)
              if (typeof item.product_id === 'string' && !item.product_id.match(/^\d+$/)) {
                const testResponse = await fetch(`/products/${item.product_id}.js`);
                if (testResponse.ok) {
                  const testProduct = await testResponse.json();
                  productHandle = testProduct.handle;
                }
              }
            } catch (e) {
              // Ignore errors, continue to fallback
            }
          }
          
          // If still no handle, use fallback
          if (!productHandle) {
            return createProductCardFallback(item);
          }
          
          // Fetch product data
          const productResponse = await fetch(`/products/${productHandle}.js`);
          if (!productResponse.ok) {
            return createProductCardFallback(item);
          }
          
          const product = await productResponse.json();
          
          // Find the variant
          const variant = product.variants.find(v => v.id === item.variant_id) || product.variants[0];
          
          // Get image
          let imageUrl = '';
          if (variant && variant.featured_image) {
            imageUrl = typeof variant.featured_image === 'string' 
              ? variant.featured_image 
              : (variant.featured_image.src || variant.featured_image.url || '');
          }
          
          if (!imageUrl && product.images && product.images.length > 0) {
            imageUrl = typeof product.images[0] === 'string' 
              ? product.images[0] 
              : (product.images[0].src || product.images[0].url || '');
          }
          
          if (!imageUrl && product.featured_image) {
            imageUrl = typeof product.featured_image === 'string' 
              ? product.featured_image 
              : (product.featured_image.src || product.featured_image.url || '');
          }
          
          // Also check item.image as fallback
          if (!imageUrl && item.image) {
            imageUrl = item.image;
          }
          
          // Format price
          const price = variant ? (variant.price / 100).toFixed(2) : (product.price / 100).toFixed(2);
          
          // Get variant title/options
          let variantTitle = '';
          if (variant) {
            const options = [];
            if (variant.option1 && variant.option1 !== 'Default Title') options.push(variant.option1);
            if (variant.option2 && variant.option2 !== 'Default Title') options.push(variant.option2);
            if (variant.option3 && variant.option3 !== 'Default Title') options.push(variant.option3);
            variantTitle = options.join(' / ');
          }
          
          return `
            <div class="bb-outro-product-card">
              ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" class="bb-outro-product-image" loading="lazy" onerror="this.style.display='none';">` : '<div class="bb-outro-product-image" style="background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999;">No Image</div>'}
              <div class="bb-outro-product-info">
                <h4 class="bb-outro-product-title">${product.title}</h4>
                ${variantTitle ? `<div class="bb-outro-product-variant">${variantTitle}</div>` : ''}
                <div class="bb-outro-product-price">£${price}</div>
              </div>
            </div>
          `;
        } catch (error) {
          console.error('Error loading product:', error);
          return createProductCardFallback(item);
        }
      });
      
      const productCards = await Promise.all(productPromises);
      html += productCards.join('');
      html += '</div>';
      
      productsContainer.innerHTML = html;
    } catch (error) {
      console.error('Error displaying selected products:', error);
      productsContainer.innerHTML = '<div class="bb-outro-products-loading">Error loading your bundle. Please refresh the page.</div>';
    }
  }
  
  function createProductCardFallback(item) {
    const price = item.price ? (item.price / 100).toFixed(2) : '0.00';
    const imageUrl = item.image || '';
    
    return `
      <div class="bb-outro-product-card">
        ${imageUrl ? `<img src="${imageUrl}" alt="${item.product_title}" class="bb-outro-product-image" loading="lazy" onerror="this.style.display='none';">` : '<div class="bb-outro-product-image" style="background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999;">No Image</div>'}
        <div class="bb-outro-product-info">
          <h4 class="bb-outro-product-title">${item.product_title || 'Product'}</h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="bb-outro-product-variant">${item.variant_title}</div>` : ''}
          <div class="bb-outro-product-price">£${price}</div>
        </div>
      </div>
    `;
  }
  
  // Initialize selected products display when outro is shown
  function initOutroSelectedProducts() {
    const outroContainer = document.querySelector('.bundle-builder-outro__container');
    if (!outroContainer) return;
    
    // Check if outro is visible
    const observer = new MutationObserver((mutations) => {
      if (outroContainer.classList.contains('show') || outroContainer.classList.contains('fade-in')) {
        displaySelectedProductsInOutro();
        observer.disconnect();
      }
    });
    
    // Also check immediately
    if (outroContainer.classList.contains('show') || outroContainer.classList.contains('fade-in')) {
      displaySelectedProductsInOutro();
    } else {
      observer.observe(outroContainer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Also listen for when outro is shown via fade-in animation
    const checkOutro = () => {
      if (outroContainer.classList.contains('show') || outroContainer.classList.contains('fade-in')) {
        setTimeout(() => {
          displaySelectedProductsInOutro();
        }, 500);
      }
    };
    
    // Check periodically when page loads
    setTimeout(checkOutro, 1000);
    setTimeout(checkOutro, 2000);
    
    // Also trigger when cart updates
    document.addEventListener('cart:updated', () => {
      if (outroContainer.classList.contains('show') || outroContainer.classList.contains('fade-in')) {
        setTimeout(() => {
          displaySelectedProductsInOutro();
        }, 300);
      }
    });
  }
  
  // Initialize outro products display
  initOutroSelectedProducts();

});
